import React, {Component} from 'react';
import {Col, Form, FormGroup, ControlLabel, FormControl} from "react-bootstrap";
import {TopButtonCancel, TopButtonSave} from "../../../../../componentsTopsa/buttons/TopButtons";
import {TopSelect} from "../../../../../componentsTopsa/selects/TopSelects";
import {TopAlertOstrzezenie} from "../../../../../componentsTopsa/alerty/TopAlerts";
import TopIf from "../../../../../componentsTopsa/if/TopIf";
import Validator from "../../../../../utilities/Validator";
import ValidatorMessages from "../../../../../shared/validatorMessages/ValidatorMessages";

export default class DefiicjeForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            trasa: null,
            przystanek: null,
            kolej: 1,
            czasOdPoprzedniego: 0,
            kmOdPoprz: 0,
            validatorMessages: [],

        };
        this.onClickZapisz = this.onClickZapisz.bind(this)
        this.onChangeTrasa = this.onChangeTrasa.bind(this)
        this.onChangePrzystanek = this.onChangePrzystanek.bind(this)
        this.onChangeKolej = this.onChangeKolej.bind(this)
        this.onChangeKmOdPoprzedniego = this.onChangeKmOdPoprzedniego.bind(this)
        this.onChangeCzasOdPoprzedniego = this.onChangeCzasOdPoprzedniego.bind(this)
    }

    componentDidMount() {
        if (Boolean(this.props.definicja)) {
            this.setState({
                trasa: this.props.trasy.find(t => t.idTr === this.props.definicja.idTr),
                przystanek: this.props.przystanki.find(p => p.idPr === this.props.definicja.idPr),
                kolej: this.props.definicja.kol,
                kmOdPoprz: (this.props.definicja.kmOdPoprz === null) ? 0 : this.props.definicja.kmOdPoprz,
                czasOdPoprzedniego: this.props.definicja.czasOdPoprz,

            })
        }
    }

    componentWillReceiveProps(nextprops) {
        if (nextprops.definicja) {
            this.setState({
                trasa: this.props.trasy.find(t => t.idTr === nextprops.definicja.idTr),
                przystanek: this.props.przystanki.find(p => p.idPr === nextprops.definicja.idPr),
                kolej: nextprops.definicja.kol,
                kmOdPoprz: (nextprops.definicja.kmOdPoprz === null) ? 0 : nextprops.definicja.kmOdPoprz,
                czasOdPoprzedniego: nextprops.definicja.czasOdPoprz,
            })
            document.getElementById('input-kolej').value = nextprops.definicja.kol;
            document.getElementById('input-km-poprzedni').value = (nextprops.definicja.kmOdPoprz === null) ? 0 : nextprops.definicja.kmOdPoprz;
            document.getElementById('input-czas-poprzedni').value = nextprops.definicja.czasOdPoprz;
        }
    }

    dodajDoValidatorMessages(msg) {
        let arr = this.state.validatorMessages;
        arr.push(msg)
        this.setState({validatorMessages: arr})
    }

    onClickZapisz() {

        let poprawne = true;
        this.state.validatorMessages = [];

        if (!Boolean(this.state.trasa)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie uzupełniono trasy')
        }

        if (!Boolean(this.state.przystanek)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie uzupełniono przystanku')

        }

        if (!Validator.validateInt(this.state.kolej, false)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nieprawidłowa kolej')

        }


        if (!Validator.validateInt(this.state.czasOdPoprzedniego, false)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nieprawidłowy czas od poprzedniego przystanku')

        }

        if (!Validator.validateIntOrDouble(this.state.kmOdPoprz, false)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nieprawidłowa ilość km od poprzedniego przystanku')
        }

        if (poprawne) {
            this.setState({validatorMessages: []})

            let data = {
                "idTr": this.state.trasa.idTr,
                "idPr": this.state.przystanek.idPr,
                "kol": this.state.kolej,
                "kmOdPoprz": this.state.kmOdPoprz,
                "czasOdPoprz": this.state.czasOdPoprzedniego,
            };
            if (Boolean(this.props.definicja)) {
                // edycja
                this.props.handleClickZapisz(data, true)
            }
            else {
                // dodawanie
                this.props.handleClickZapisz(data, false)
            }
        }
    }

    formatTrasaSelect(option) {
        return <div><span className={'label label-ebus-default'}>{option.kodTrasy}</span> {option.nazTr}</div>
    }

    formatPrzystanekSelect(option) {
        return <div><span className={'label label-ebus-default'}>{option.nazMi}</span> {option.nazPr}</div>
    }

    onChangeTrasa(e) {
        this.setState({trasa: e})
    }

    onChangePrzystanek(e) {
        this.setState({przystanek: e})
    }

    onChangeKolej(e) {
        if (e.target.value > 0) {

            this.setState({kolej: e.target.value})

            if (e.target.value == 1) {
                document.getElementById('input-km-poprzedni').value = 0;
                document.getElementById('input-czas-poprzedni').value = 0;
                this.setState({kmOdPoprz: 0, czasOdPoprzedniego: 0})
            }
        }
        else {
            this.setState({kolej: 1})
            document.getElementById('input-kolej').value = 1;
        }
    }

    onChangeKmOdPoprzedniego(e) {
        if (e.target.value >= 0) {
            this.setState({kmOdPoprz: e.target.value})
        }
        else {
            Validator.addClearing('input-km-poprzedni', this.state.kmOdPoprz)
        }
    }

    onChangeCzasOdPoprzedniego(e) {
        if (e.target.value >= 0) {
            this.setState({czasOdPoprzedniego: e.target.value})
        }
        else {
            Validator.addClearing('input-czas-poprzedni', this.state.czasOdPoprzedniego)
        }
    }

    render() {

        return (
            <div>
                <h4>{Boolean(this.props.definicja) ? 'Edycja ' : 'Dodawanie '} definicji</h4>
                <Form horizontal={true}>
                    <FormGroup>
                        <Col xs={12} sm={12} md={6} lg={3}>
                            <ControlLabel>
                                Trasa <span className={'req'}>*</span>
                            </ControlLabel>
                            <TopSelect onChange={this.onChangeTrasa}
                                       value={this.state.trasa}
                                       options={this.props.trasy}
                                       valueKey={'idTr'}
                                       labelKey={'nazTr'}
                                       valueRenderer={this.formatTrasaSelect}
                                       optionRenderer={this.formatTrasaSelect}
                            />
                        </Col>
                        <Col xs={12} sm={12} md={6} lg={3}>
                            <ControlLabel>
                                Przystanek <span className={'req'}>*</span>
                            </ControlLabel>
                            <TopSelect onChange={this.onChangePrzystanek}
                                       value={this.state.przystanek}
                                       options={this.props.przystanki}
                                       valueKey={'idPr'}
                                       labelKey={'nazMi'}
                                       valueRenderer={this.formatPrzystanekSelect}
                                       optionRenderer={this.formatPrzystanekSelect}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup>
                        <Col xs={12} sm={6} md={4} lg={1}>
                            <ControlLabel>
                                Kolej <span className={'req'}>*</span>
                            </ControlLabel>
                            <FormControl type='number' onChange={this.onChangeKolej}
                                         defaultValue={Boolean(this.props.definicja) ? this.props.definicja.kol : 1} id={'input-kolej'}/>
                        </Col>
                        <Col xs={12} sm={6} md={4} lg={2}>
                            <ControlLabel>
                                Czas od poprzedniego <span className={'req'}>*</span>
                            </ControlLabel>
                            <FormControl type='number' onChange={this.onChangeCzasOdPoprzedniego}
                                         defaultValue={Boolean(this.props.definicja) ? this.props.definicja.czasOdPoprz : 0}
                                         id={'input-czas-poprzedni'}
                                         disabled={Boolean(this.state.kolej == 1)}/>
                        </Col>
                        <Col xs={12} sm={6} md={4} lg={2}>
                            <ControlLabel>
                                Km od poprzedniego <span className={'req'}>*</span>
                            </ControlLabel>
                            <FormControl type='number' onChange={this.onChangeKmOdPoprzedniego}
                                         defaultValue={Boolean(this.props.definicja) ? this.props.definicja.kmOdPoprz : 0}
                                         id={'input-km-poprzedni'}
                                         disabled={Boolean(this.state.kolej == 1)}/>
                        </Col>
                        <Col xs={12} sm={6} md={6} lg={3}>
                            <div className={'add-label-margin'}></div>
                            <TopButtonCancel onClick={() => {
                                this.props.handleClickAnuluj()
                            }} text={'Anuluj'}/>
                            <TopButtonSave onClick={this.onClickZapisz} text={'Zapisz'}/>
                        </Col>
                        <TopIf isTrue={this.state.kolej == 1}>
                            <Col xs={12}>
                                <div style={{marginTop: '5px'}}>
                                    <TopAlertOstrzezenie text={'Czas oraz km poprzedniego przystanku są zablokowane, ponieważ kolej wynosi 1'}/>
                                </div>
                            </Col>
                        </TopIf>
                    </FormGroup>
                    <FormGroup>
                        <ValidatorMessages messages={this.state.validatorMessages}/>
                    </FormGroup>
                </Form>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/trasyConfig/defiicje/components/DefiicjeForm.js